import { en } from './en'
import { fr } from './fr'

export const impactCard = {
  en,
  fr
}